// Replace with your Trustpilot API key and Business Unit ID
const API_KEY = 'AGXtMsGLzdWGzzGsrCg29gPn7xTeu7zd';
const BUSINESS_UNIT_ID = '533895d80000640005787b34';
const CACHE_KEY = 'ODtrustpilotWidgetData';
const CACHE_EXPIRATION = 3600000 * 12;

// Function to fetch Trustpilot data
async function fetchTrustpilotSummary() {
  const cachedData = getCachedWidgetData();

  if (cachedData) {
    setupCustomWidget(cachedData);
    return;
  }

  const url = `https://api.trustpilot.com/v1/business-units/${BUSINESS_UNIT_ID}/`;

  try {
    const response = await fetch(url, {
      headers: {
        'apikey': `${API_KEY}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching Trustpilot data: ${response.statusText}`);
    }

    const data = await response.json();

    // Extract relevant data for the widget
    const widgetData = {
      starRatingImg: `https://images-static.trustpilot.com/api/stars/${data.score.stars}/star.svg`,
      starRatingNum: data.score.stars,
      trustScore: data.score.trustScore,
      totalReviews: data.numberOfReviews.total,
    };

    // Cache the widget data
    cacheWidgetData(widgetData);

    // Assign widgetData to your custom widget
    setupCustomWidget(widgetData);

  } catch (error) {
    console.error('Error:', error);
  }
}

// Function to set up the custom widget
function setupCustomWidget(data) {
  document.querySelector('#trust-score').textContent = data.trustScore;
  document.querySelector('#total-reviews').textContent = data.totalReviews;

  const starRating = document.querySelector('#star-rating');
  starRating.src = data.starRatingImg;
  starRating.alt = `${data.starRatingNum} stars out of 5 stars`;
}

// Function to get cached widget data
function getCachedWidgetData() {
  const cached = localStorage.getItem(CACHE_KEY);

  if (!cached) {
    return null;
  }

  const { data, timestamp } = JSON.parse(cached);

  // Check if the cached data has expired
  if (Date.now() - timestamp > CACHE_EXPIRATION) {
    localStorage.removeItem(CACHE_KEY); // Remove expired data
    return null;
  }

  return data;
}

// Function to cache widget data
function cacheWidgetData(data) {
  const cacheEntry = {
    data,
    timestamp: Date.now()
  };

  localStorage.setItem(CACHE_KEY, JSON.stringify(cacheEntry));
}

// Call the function to fetch and display Trustpilot data
if (document.querySelector('#trustpilot-widget')) {
  fetchTrustpilotSummary();
}
